export type DatabaseDefaults = {
  createdAt: string;
  deletedAt: string | null;
  updatedAt: string;
  id: string;
  groupId: string;
};

export const databaseDefaultsShape: DatabaseDefaults = {
  createdAt: "",
  deletedAt: null,
  updatedAt: "",
  id: "",
  groupId: "",
};
